import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import { fetchInvoice } from '../../Invoices/actions';
import { getPropByName } from '../../../utils/props';
import { formatCurrency, formatCurrencyValue } from '../../../utils/string';
import {
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
  VEHICLE_PURPOSE
} from '../constants';
import { fetchUser } from '../../Users/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_USER } from '../../Users/constants';
import { selectUser } from '../../Users/selectors';
import { Loader } from 'react-feather';
import { PURCHASING_DATA_CRUD, PURCHASING_PRICES_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { InvoiceStatus } from '../../Invoices/components/InvoiceStatus';
import { getDate } from '../helpers';
import cn from 'classnames';
import styles from './CardFinancePurchase.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { OnMouseOverNotification } from './OnMouseOverNotification';
import { hasPermissions } from '../../../utils/helpers/permissions';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .status-label {
    width: fit-content;
  }

  .cell-value {
    white-space: nowrap;
  }
  .cell-creditor {
    text-align: right;
  }
`;

const STATE = {
  incomingInvoice: null,
  userBuyer: null,
  isOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleFinancePurchaseCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_FINANCE)) {
      this.setState({ isOpen: true });
    }
    if (this.props.vehicle?.user_buyer_id) {
      this.props.fetchUser(this.props.vehicle?.user_buyer_id, res => {
        if (res?.id) {
          this.setState({ userBuyer: res });
        }
      });
    }
    this.props.vehicle?.incoming_invoice &&
      this.props.fetch(this.props.vehicle?.incoming_invoice, res => {
        if (res?.id) {
          this.setState({ incomingInvoice: res });
        }
      });
  }

  get purchasingDataProps() {
    return ['creditor_company', 'user_buyer_id'];
  }

  get purchasingPricesProps() {
    return [
      'vehicle_purpose',
      'tax_type',
      'economic_prize',
      'financial_purchase_price_incl_bpm_excl_btw',
      ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
      ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
    ];
  }

  wrapFieldIntoPermissionsComp(component) {
    if (env.clientId != AppClientId.AUTOWIENTJES) return component;
    return;
  }

  renderField(property, data) {
    const { vehicle, economicPrize, creditorCompany } = data;

    if (property == 'creditor_company') {
      let label = getPropByName(creditorCompany, 'name') || '';

      if (getPropByName(creditorCompany, 'company_type') === 'individual') {
        label = `${getPropByName(creditorCompany, 'name') || ''} ${getPropByName(creditorCompany, 'surname') || ''}`;
      }
      return (
        vehicle[property] && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-creditor">
              <Link to={`/companies/${creditorCompany?.id || ''}`}>{label}</Link>
            </Cell>
          </Row>
        )
      );
    }

    if (property == 'user_buyer_id') {
      return (
        vehicle[property] && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            {this.props.workUser ? (
              <Loader small />
            ) : (
              <Cell className="cell-value">{`${getPropByName(this.props.userBuyer, 'name') || ''} ${getPropByName(
                this.props.userBuyer,
                'surname',
              ) || ''}`}</Cell>
            )}
          </Row>
        )
      );
    }

    if (
      property == 'financial_purchase_price_marge_bpm' ||
      property == 'rest_bpm' ||
      property == 'taxiVerleden' ||
      property == 'financial_purchase_price_marge_excl_bpm' ||
      property == 'financial_bpm_gross' ||
      property == 'financial_purchase_price_incl_vat_bpm' ||
      property == 'financial_purchase_price_incl_vat_excl_bpm' ||
      property == 'vat_amount' ||
      property == 'financial_purchase_price_excl_vat_excl_bpm' ||
      property == 'financial_purchase_price_incl_bpm_excl_btw' ||
      property == 'financial_bpm_gross' ||
      property == 'economic_prize' ||
      property == 'orb_incoming_complete' ||
      property == 'incoming_invoice_generated_date'
    ) {
      if (property == 'economic_prize') {
        return this.wrapFieldIntoPermissionsComp(
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-value">{formatCurrencyValue(vehicle[property])} </Cell>
          </Row>,
        );
      }

      if (property == 'rest_bpm') {
        const isShowRestBpm = vehicle?.vehicle_purpose !== 'commercial' && vehicle[property];
        return (
          isShowRestBpm && (
            <Row key={property}>
              <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
              <Cell className="cell-value">
                {vehicle.taxiVerleden === '1' ? (
                  <HBox right vCenter>
                    {formatCurrencyValue(vehicle[property])}
                    {vehicle.taxiVerleden === '1' && (
                      <OnMouseOverNotification message={this.lbl('alert.is_taxi_tax_message')} />
                    )}
                  </HBox>
                ) : (
                  formatCurrencyValue(vehicle[property])
                )}
              </Cell>
            </Row>
          )
        );
      }

      if (property == 'taxiVerleden') {
        const isShowRestBpm = vehicle?.vehicle_purpose !== 'commercial' && vehicle[property];
        return (
          isShowRestBpm && (
            <Row key={property}>
              <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
              <Cell className="cell-value">{vehicle[property] === '1' ? this.lbl('yes') : this.lbl('no')}</Cell>
            </Row>
          )
        );
      }

      if (property == 'orb_incoming_complete') {
        return (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-value">{vehicle[property]}</Cell>
          </Row>
        );
      }

      if (property === 'incoming_invoice_generated_date') {
        const dateString = vehicle[property];

        // Check if dateString is valid
        if (dateString) {
          const date = new Date(dateString);
          if (!isNaN(date.getTime())) {
            // Check if date is a valid date
            const day = date
              .getDate()
              .toString()
              .padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const formattedDate = `${day}-${month}-${year}`;
            return (
              <Row key={property}>
                <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                <Cell className="cell-value">{formattedDate}</Cell>
              </Row>
            );
          }
        }

        // Return null if dateString is not valid
        return null;
      }

      return (
        vehicle[property] && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-value">{formatCurrencyValue(vehicle[property])}</Cell>
          </Row>
        )
      );
    }

    if (property == 'paymentStatus') {
      return (
        this.state.incomingInvoice?.status && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.info.finance.payment_status`)}</Cell>
            <Cell>
              <InvoiceStatus className="status-label" status={this.state.incomingInvoice?.status?.name} />
            </Cell>
          </Row>
        )
      );
    }

    return (
      vehicle[property] && (
        <Row key={property}>
          <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
          <Cell className="cell-value">{this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}</Cell>
        </Row>
      )
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const { incomingInvoice } = this.state;
    const creditorCompany = vehicle.creditorCompany;
    let economicPrize = null;
    let typesArr = ['creditor_company', 'user_buyer_id', 'vehicle_purpose', 'tax_type'];
    if (vehicle['tax_type'] === 'BTW') {
      economicPrize = (+vehicle?.financial_purchase_price_incl_vat_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
      typesArr = typesArr.concat(...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW);

      const isCommercial = vehicle?.vehicle_purpose === VEHICLE_PURPOSE.Commercial;
      const dateFirstAllowance = this.props.values?.date_first_allowance;
      const is2025OrLater = dateFirstAllowance ? new Date(dateFirstAllowance).getFullYear() >= 2025 : true;
      if (isCommercial && dateFirstAllowance && is2025OrLater) typesArr.push('financial_purchase_price_incl_bpm_excl_btw');
    }
    if (vehicle['tax_type'] === 'marge') {
      economicPrize = (+vehicle?.financial_purchase_price_marge_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
      typesArr = typesArr.concat(...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE);
    }
    const data = {
      vehicle,
      economicPrize,
      creditorCompany,
    };

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.finance.purchase.purchasing_data')}</h2>
            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <List className={styles.list}>
              {[...typesArr].map(property => {
                let permission = null;
                if (this.purchasingDataProps.includes(property)) permission = PURCHASING_DATA_CRUD;
                if (this.purchasingPricesProps.includes(property)) permission = PURCHASING_PRICES_CRUD;

                return <Permission permission={permission}>{this.renderField(property, data)}</Permission>;
              })}
              {/* <Row>
                <Cell>{this.lbl(`vehicle.property.orb_incoming_complete`)}</Cell>
                <Cell>{getDate(vehicle?.purchase_release_done_date)}</Cell>
              </Row> */}
            </List>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleFinancePurchaseCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workUser: selectWork(REQUEST_USER),
    userBuyer: selectUser(ownProps.vehicle?.user_buyer_id),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(invoiceId, callback) {
      dispatch(fetchInvoice(invoiceId, callback));
    },
    fetchUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleFinancePurchaseCard = compose(withConnect, withRouter)(VehicleFinancePurchaseCardComp);
